import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { SeismicCurrencyDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-seismic-currency-container',
  templateUrl: './seismic-currency-container.component.html',
  styleUrls: ['./seismic-currency-container.component.scss'],
})
export class SeismicCurrencyContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  currencys$: Observable<SeismicCurrencyDto[]>;
  loading: boolean;
  isLoadingCurrency$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingCurrency$ = this.gatwayFacade.isLoadingGateway(
      'SeismicCurrency'
    );
    this.currencys$ = this.gatwayFacade.loadGateway('SeismicCurrency');
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteCurrency(deletedValue: any) {
    this.gatwayFacade.remove('SeismicCurrency', deletedValue);
  }

  // this method control both the create and update

  onSubmitCurrency(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Currencys;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllCurrency = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllCurrency.push(pullData[i]);
      }
    }

    // check if the addAllCurrency array is not empty, then dispatch the data to the store
    if (addAllCurrency.length > 0) {
      this.gatwayFacade.add('SeismicCurrency', addAllCurrency);
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('SeismicCurrency', allUpdates, ['id']);
    }
  }
}
